import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';

@Injectable({providedIn: 'root'})
export class HttpErrorService {
	public show$ = new Subject<void>();
}
